// extracted by mini-css-extract-plugin
module.exports = {"card":"ServiceSubscription_card__38atC","container":"ServiceSubscription_container__3CrFE","info":"ServiceSubscription_info__1MNfY"};